// extracted by mini-css-extract-plugin
module.exports = {"declaration":"By+hdHfFFJ6hEUBOSsGIYw==","footer":"MxEV-Z1DDQm76JpjqobBnA=="};